import { render, staticRenderFns } from "./TreatmentPlan.vue?vue&type=template&id=694bac20&scoped=true&lang=pug&"
import script from "./TreatmentPlan.vue?vue&type=script&lang=js&"
export * from "./TreatmentPlan.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentPlan.vue?vue&type=style&index=0&id=694bac20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694bac20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VDivider,VIcon,VProgressLinear,VRow,VSkeletonLoader,VTab,VTabs,VTabsSlider})
